import { render, staticRenderFns } from "./Responsive.vue?vue&type=template&id=1564fc81&scoped=true"
var script = {}
import style0 from "./Responsive.vue?vue&type=style&index=0&id=1564fc81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564fc81",
  null
  
)

export default component.exports